import { Link } from "react-router-dom";

const CHI_SIAMO_PHOTO =
  "https://images.unsplash.com/photo-1526478806334-5fd488fcaabc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxsaXZlJTIwbXVzaWMlMjBwZXJmb3JtYW5jZSUyMHN0YWdlJTIwc2lsaG91ZXR0ZSUyMGxpZ2h0c3xlbnwwfHx8fDE3OTA2MDk5OTZ8MA&ixlib=rb-4.1.0&q=85";

export default function ChiSiamo() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8" data-testid="chi-siamo-page">
      <h1 className="section-title">Chi siamo</h1>
      <div className="mt-8 overflow-hidden rounded-xl border border-gold/40 shadow-xl ring-1 ring-inset ring-gold/20" data-testid="chi-siamo-photo-frame">
        <img src={CHI_SIAMO_PHOTO} alt="Musicisti sul palco durante un'esibizione dal vivo" className="max-h-[380px] w-full object-cover" />
      </div>
      <div className="mt-6 space-y-4 text-base leading-relaxed text-foreground/80">
        <p>
          <strong className="text-bordeaux">ENPALSBOX</strong> è la piattaforma dedicata ad artisti e lavoratori
          dello spettacolo che vogliono gestire in modo semplice gli adempimenti previdenziali collegati alla
          propria attività.
        </p>
        <p>
          Il nostro obiettivo è uno solo: lasciarti libero di pensare alla musica e al tuo lavoro artistico,
          mentre noi ci occupiamo della burocrazia. Ti assistiamo nella richiesta del certificato di agibilità
          e ti offriamo informazioni chiare su F24 e dichiarazione mensile.
        </p>
        <p>
          Oltre 1.000 artisti si sono già affidati a ENPALSBOX. Professionalità, affidabilità e semplicità sono
          i valori che guidano ogni nostro servizio.
        </p>
      </div>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link to="/iscriviti" data-testid="chi-siamo-register-btn" className="btn-bordeaux">ISCRIVITI</Link>
        <Link to="/contatti" data-testid="chi-siamo-contact-btn" className="btn-outline-bordeaux">CONTATTACI</Link>
      </div>
    </div>
  );
}
